/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { LocalizedFieldBody } from './localized-field-body';

/**
 * 
 * @export
 * @interface LayoutModuleError
 */
export interface LayoutModuleError {
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof LayoutModuleError
     */
    moduleTitle: LocalizedFieldBody;
    /**
     * 
     * @type {string}
     * @memberof LayoutModuleError
     */
    collectionId?: string;
    /**
     * 
     * @type {string}
     * @memberof LayoutModuleError
     */
    moduleType?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LayoutModuleError
     */
    targetPlatform?: Array<LayoutModuleErrorTargetPlatformEnum>;
}

/**
    * @export
    * @enum {string}
    */
export enum LayoutModuleErrorTargetPlatformEnum {
    FIRETABLET = 'firetablet',
    ANDROID = 'android',
    ANDROIDTV = 'androidtv',
    COMCASTTV = 'comcasttv',
    FIRETV = 'firetv',
    IOS = 'ios',
    LGTV = 'lgtv',
    ROKU = 'roku',
    SAMSUNG_GALAXY = 'samsung_galaxy',
    SAMSUNGTV = 'samsungtv',
    TIGOSTB = 'tigostb',
    TVOS = 'tvos',
    VEGA = 'vega',
    VIDAATV = 'vidaatv',
    VIZIOTV = 'viziotv',
    WEB = 'web',
    WEBTV = 'webtv'
}



